import { combineEpics } from 'redux-observable';
import { ff } from '@atlassian/jira-feature-flagging';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import type { State, Action } from '../../state/types';
import { clearFilterRequestEpic } from './clear-filter-request';
import { filteredCardsRequestEpic } from './filter-request';
import { refilterRequestEpic as refilterRequestEpicOld } from './refilter-request';
import { refilterRequestEpicNew } from './refilter-request-new';

const refilterRequestEpic = functionWithCondition(
	() => ff('issue.dee-3496-batch-realtime-update'),
	refilterRequestEpicNew,
	refilterRequestEpicOld,
);

export const filteredCardsEpic = combineEpics<Action, State>(
	filteredCardsRequestEpic,
	refilterRequestEpic,
	clearFilterRequestEpic,
);
